import { PatientDetailDiaLogTabMap } from '~/constants/tab';

export type TabType = (typeof PatientDetailDiaLogTabMap)[keyof typeof PatientDetailDiaLogTabMap];

export type PatientDetailDialog = {
  isOpen: boolean;
  patientId: string | null;
  type: TabType;
  eventId: number | null;
  recommendationPresetCode: string | null;
};

export type PatientDetailDialogTracingReport = {
  selectedSheetId: string | null;
};

export type PatientDetailDialogPatientComment = {
  selectedCommentId: string | null;
  isDeleteModalOpen: boolean;
};

export type PatientDetailDialogMessage = {
  profile: Profile | null;
  selectedMessageId: string | null;
  draftMessageId: string | null;
  messageInfoStatus: 'created' | 'new' | 'sendAt' | null;
  messageInfoIsOpen: boolean;
};

export type EventPageInfo = {
  isResetEvent: boolean;
  page: number;
  perPage: number;
};

export type Answer = {
  answer: string | null;
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 20;

type Profile = {
  type?: 'DirectVisitor' | 'Patient' | 'WebVisitor' | 'LineVisitor';
  appointmentId: string | null;
  guestPatientId: string | null;
  patientId: string | null;
  familyName: string;
  givenName: string;
  phoneticFamilyName: string;
  phoneticGivenName: string;
  visitDay?: string;
};

export type PatientDetailDialogProfile = {
  type: 'edit' | null;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PatientDetailDiaLogActionMap = {
  close: 'close',
  message: 'toTracingReport',
} as const;

export type PatientDetailDiaLogActionType =
  (typeof PatientDetailDiaLogActionMap)[keyof typeof PatientDetailDiaLogActionMap];

export type PatientDetailConfirmBreakaway = {
  isOpen: boolean;
  action: PatientDetailDiaLogActionType | null;
};

export type DeleteMedicationFollowupMessageModal = {
  isOpen: boolean;
  medicationFollowupMessageId: string | null;
};

export type PatientDetailDialogPatientMobilePhone = {
  isOpen: boolean;
};
